<div class="signup-wrapper">
  @if (isSubmitted) {
    <div class="success-container">
      <div class="success-icon">
        <svg
          width="55"
          height="55"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="32" cy="32" r="32" fill="#E8F5E9" />
          <path
            d="M44 24L28 40L20 32"
            stroke="#008037"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h2>Next stop: Your inbox!</h2>
      <p>
        We just sent a registration link to your email address. If you're new
        here, simply follow the link to complete your profile and dive right
        into your account.
      </p>
      <button class="back-button" (click)="onBackToLogin()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 15L7.5 10L12.5 5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Back to Login
      </button>
    </div>
  } @else {
    <div class="signup-form">
      <div class="form-header">
        <h2>Small Business Signup</h2>
        <p>Register your small or medium enterprise</p>
      </div>

      <div class="form-group">
        <label for="signupEmail">
          Email Address
          <span class="required">*</span>
        </label>
        <div class="input-wrapper">
          <svg
            class="input-icon"
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.33333 3.33337H16.6667C17.5833 3.33337 18.3333 4.08337 18.3333 5.00004V15C18.3333 15.9167 17.5833 16.6667 16.6667 16.6667H3.33333C2.41666 16.6667 1.66666 15.9167 1.66666 15V5.00004C1.66666 4.08337 2.41666 3.33337 3.33333 3.33337Z"
              stroke="#999"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.3333 5L9.99999 10.8333L1.66666 5"
              stroke="#999"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <input
            id="signupEmail"
            type="email"
            [(ngModel)]="signupEmail"
            placeholder="you@example.com"
            [class.invalid]="signupEmail.trim() && !isValidEmail(signupEmail)"
          />
        </div>
        @if (signupEmail.trim() && !isValidEmail(signupEmail)) {
          <span class="error-text">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 1.33337C4.32 1.33337 1.33333 4.32004 1.33333 8.00004C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004C14.6667 4.32004 11.68 1.33337 8 1.33337ZM8.66666 11.3334H7.33333V10H8.66666V11.3334ZM8.66666 8.66671H7.33333V4.66671H8.66666V8.66671Z"
                fill="#EF4444"
              />
            </svg>
            Please enter a valid email address
          </span>
        }
      </div>

      <div class="form-actions">
        <button
          class="submit-button"
          (click)="onSignup()"
          [disabled]="
            isSigningUp || !signupEmail.trim() || !isValidEmail(signupEmail)
          "
        >
          @if (isSigningUp) {
            <svg
              class="spinner"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 2V5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Signing up...
          } @else {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6667 5L7.50001 14.1667L3.33334 10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Submit Registration
          }
        </button>
        <button class="back-link" (click)="onBackToLogin()">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 15L7.5 10L12.5 5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Back to Login
        </button>
      </div>
    </div>
  }
</div>
